export default __webpack_public_path__ + "static/media/footer3-bg.ea1bfc06.png";